/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Tag as AntTag } from 'antd';

import styles from './Tag.less';

const Tag = ({ color = 'volcano', children, ...rest }) => {
  return (
    <AntTag color={color} {...rest} className={styles.tag}>
      {children}
    </AntTag>
  );
};

export default Tag;
